// components/Apps/Quiz/ScaleAnswerOptions.js
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Atoms';

const ScaleAnswerOptions = ({ scaleLabelLow, scaleLabelHigh, selectedAnswer, onAnswer }) => {
  return (
    <div className="quiz-scale">
      <span className="quiz-scale__label">{scaleLabelLow}</span>
      <div className="quiz-scale__buttons">
        {[1, 2, 3, 4, 5].map((value) => (
          <Button
            key={value}
            variant={selectedAnswer === value ? 'solid' : 'outline'}
            onClick={() => onAnswer(value)}
            className="quiz-scale__button"
          >
            {value}
          </Button>
        ))}
      </div>
      <span className="quiz-scale__label">{scaleLabelHigh}</span>
    </div>
  );
};

ScaleAnswerOptions.propTypes = {
  scaleLabelLow:  PropTypes.string,
  scaleLabelHigh: PropTypes.string,
  selectedAnswer: PropTypes.number,
  onAnswer:       PropTypes.func.isRequired,
};

export default ScaleAnswerOptions;